import type { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { usePdfPreviewContext } from '../../pdf-preview-context.tsx';
import type { ClientDetails as ClientDetailsType } from '../../types';
import { ClientDetailsPlaceholder } from '../../placeholders';
import { Detail, Details } from './details.tsx';

interface ClientDetailsProps {
  client?: ClientDetailsType;
}

export function ClientDetails({ client }: ClientDetailsProps): ReactNode {
  const { formatMessage } = useIntl();
  const { displayLanguage } = usePdfPreviewContext();

  return (
    <ClientDetailsPlaceholder>
      {client?.vatNumber || client?.tinNumber ? (
        <Details>
          {client.vatNumber ? (
            <Detail
              data-testid="pdf-preview-client-vat-number"
              detailType="client"
              label={formatMessage(
                { id: 'pdf-preview.client-ust-udnr' },
                { language: displayLanguage }
              )}
              value={client.vatNumber}
            />
          ) : null}
          {client.tinNumber ? (
            <Detail
              data-testid="pdf-preview-client-tin-number"
              detailType="client"
              label={formatMessage(
                { id: 'pdf-preview.client-steuer-id' },
                { language: displayLanguage }
              )}
              value={client.tinNumber}
            />
          ) : null}
        </Details>
      ) : null}
    </ClientDetailsPlaceholder>
  );
}
